import gql from 'graphql-tag';
import { ref } from 'vue';
import { route } from '@router/router';
import { useQuery } from '@vue/apollo-composable';

const GET_LP_USAGE_QUERY = gql`
    query getLpPageStatisticsInfo($profileId: String!) {
        getLpPageStatisticsInfo(profileId: $profileId) {
            profileId
            Created
            Running
        }
    }
`;
export interface LpModuleUsageType {
    profileId?: string;
    Created: number;
    Running: number;
}

export { lpModuleUsage };

const lpModuleUsage = ref<LpModuleUsageType | undefined>();
const lpModuleUsageLoading = ref(false);

export function useLpUsage() {
    const getLpUsage = (params?: {
        sid?: string;
        resultCallback?: (T: LpModuleUsageType) => void;
        rejectCallback?: (err: any) => void;
        finallyCallback?: (T: any) => void;
    }) => {
        const profileId = params?.sid || route.value.params?.sid;
        if (!profileId) return;

        const { onResult, onError } = useQuery<{ getLpPageStatisticsInfo: LpModuleUsageType }>(
            GET_LP_USAGE_QUERY,
            {
                profileId
            },
            {
                fetchPolicy: 'no-cache'
            }
        );

        onResult(data => {
            if (data?.data?.getLpPageStatisticsInfo) {
                lpModuleUsage.value = data?.data?.getLpPageStatisticsInfo || {};
                params?.resultCallback &&
                    typeof params?.resultCallback === 'function' &&
                    params?.resultCallback(data.data.getLpPageStatisticsInfo);
                params?.finallyCallback &&
                    typeof params?.finallyCallback === 'function' &&
                    params?.finallyCallback(data.data.getLpPageStatisticsInfo);
            }
            lpModuleUsageLoading.value = false;
        });

        onError(err => {
            lpModuleUsage.value = undefined;
            lpModuleUsageLoading.value = false;
            params?.rejectCallback &&
                typeof params?.rejectCallback === 'function' &&
                params?.rejectCallback(err);
            params?.finallyCallback &&
                typeof params?.finallyCallback === 'function' &&
                params?.finallyCallback(err);
        });
    };

    return {
        lpModuleUsage,
        lpModuleUsageLoading,

        getLpUsage
    };
}
